import React from 'react';
import checkbox from 'assets/images/icons/icon-checkbox.svg';

import { MobileFeature, CheckMarkIcon } from './PlaceCardMobileFeature.styles';

interface PlaceCardMobileFeatureProps {
  feature: string;
}

export const PlaceCardMobileFeature: React.FC<PlaceCardMobileFeatureProps> = ({ feature }) => (
  <MobileFeature>
    <CheckMarkIcon alt="checkbox icon" src={checkbox} />
    {feature}
  </MobileFeature>
);
